import {useSubheader} from "../../../_metronic/layout";
import React, {useState} from "react";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {makeFormDataRequest} from "../../api/makeRequest";


export const ServiceModifyPage = () => {
	const { t } = useTranslation('common');
	const suhbeader = useSubheader();
	suhbeader.setTitle(t('EditServiceInformation'));

	const [loading, setLoading] = useState(false);
	const [okMessage,setOkMessage] = useState('');

	const [file,setFile] = useState(null)
	const [name,setName] = useState('')
	const [loginName,setLoginName] = useState('')
	const [status,setStatus] = useState("")
	const [errors,setErrors] = useState({})


	const enableLoading = () => {
		setLoading(true);
	};

	const disableLoading = () => {
		setLoading(false);
	};


	let history = useHistory();

	const handleSubmit = (e)=>{
		e.preventDefault()
		enableLoading();
		if(!file && !name && !loginName){
			setStatus(t('fillOne'))
			return
		}
		const formData = new FormData()
		formData.append('name',name)
		formData.append('loginName',loginName)
		formData.append('image',file)
		makeFormDataRequest('panel/import/service',formData )
			.then(({data}) => {
			const {success} = data
			if(success) {
				setOkMessage(t('UpdateDone'))
				setTimeout(()=>{
					history.push('/service')
				},1000)
			}else{
				const {error} = data
				setStatus(error)
			}
		}).catch((e) => {
			setStatus(t('Error'))
		}).finally(() => {
			disableLoading();
		})
	}

	return (
		<>
			<form
				onSubmit={handleSubmit}
				className="form fv-plugins-bootstrap fv-plugins-framework"
			>
				{status ? (
					<div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
						<div className="alert-text font-weight-bold">{status}</div>
					</div>
				) : null}
				{okMessage ? (
					<div className="mb-10 alert alert-custom alert-light-success alert-dismissible">
						<div className="alert-text font-weight-bold">{okMessage}</div>
					</div>
				) : null}
				<div className="form-group fv-plugins-icon-container">
					<label htmlFor='name'>{t('ServiceDisplayName')}</label>
					<input
						type="text"
						className={`form-control form-control-solid h-auto py-5 px-6`}
						name="name"
						id="name"
						onChange={(e)=>{
							setName(e.target.value)
						}}
					/>
					{errors.name ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{errors.name}</div>
						</div>
					) : null}
				</div>
				<div className="form-group fv-plugins-icon-container">
					<label htmlFor='name'>{t('LoginBTM')}</label>
					<input
						type="text"
						className={`form-control form-control-solid h-auto py-5 px-6`}
						name="loginName"
						id="loginName"
						onChange={(e)=>{
							setLoginName(e.target.value)
						}}
					/>
					{errors.name ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{errors.loginName}</div>
						</div>
					) : null}
				</div>
				<div className="form-group fv-plugins-icon-container">
					<label htmlFor='image'>{t('ServiceImage')} ({t('SuggestedSize')} 512 * 512)</label>
					<input
						type="file"
						id='image'
						className={`form-control form-control-solid h-auto py-5 px-6`}
						name="image"
						onChange={(e)=>{

							if(e.target.files.length < 1){
								setErrors(prev=>({
									...prev,
									image:t('SelectFile')
								}))
								setFile(null)
								e.target.value = null
								return;
							}

							if(!e.target.files[0].name.toLowerCase().includes('jpg') &&
								!e.target.files[0].name.toLowerCase().includes('jpeg') &&
								!e.target.files[0].name.toLowerCase().includes('png') &&
								!e.target.files[0].name.toLowerCase().includes('gif')
							){
									setErrors(prev=>({
										...prev,
										image:"(gif,jpg,jpeg,png) t('Format')"
									}))
								e.target.value = null
									return;
							}

							let lenMb = parseInt(e.target.files[0].size / 1024 / 1024 * 10)/10;

							if(lenMb > 5){
								setErrors(prev=>({
									...prev,
									image:t('SizeMax')
								}))
								e.target.value = null
								return;
							}
							setFile(e.target.files[0]);
						}}
					/>
					{errors.image ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{errors.image}</div>
						</div>
					) : null}
				</div>

				<div className="form-group d-flex flex-wrap justify-content-between align-items-center">
					<button
						id="kt_login_signin_submit"
						type="submit"
						disabled={loading}
						className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
					>
						<span>{t('Import')}</span>
						{loading && <span className="blockui m-1 ml-3 spinner spinner-white"/>}
					</button>
				</div>
			</form>
		</>
	)
}
